import { useAuth } from "common/auth/Auth";
import { H4, Paragraph } from "common/components/Typography";
import { SelectExamSyllabus } from "domain/exam-syllabus/SelectExamSyllabus";
import React from "react";
import { GetMyStudyProgrammes_studyProgrammeList } from "__generated__/types";

interface Props {
  studyProgrammes: GetMyStudyProgrammes_studyProgrammeList[];
}

export const SelectExamSyllabi: React.FC<React.PropsWithChildren<Props>> = ({
  studyProgrammes,
}) => {
  const auth = useAuth();

  return (
    <>
      <H4>Hvilket pensum jobber du med nå?</H4>
      {auth.me?.menu.admin && (
        <Paragraph>
          <em>
            Du er logget inn som admin, men kan likevel velge eksamenspensum for
            å se hvordan Mitt pensum ser ut for studenter.
          </em>
        </Paragraph>
      )}
      {studyProgrammes.map((s) => (
        <SelectExamSyllabus key={s.id} studyProgramme={s} />
      ))}
      {!studyProgrammes.length &&
        "Oisann! Vi fant ikke noe pensum. Er du sikker på at du har valgt hvilket studieprogram du går på?"}
    </>
  );
};
